import { createTheme } from '@mui/material/styles';

export const muiTheme = createTheme({
  components: {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0, 0, 0, 0.11)',
        },
      },
    },
  },
});
